export default "__VITE_ASSET__66aceb9e__"